import React from 'react';
import { CLIENT_LOGOS } from '../homeData';
import './HomeClients.css';

const MARQUEE_LOGOS = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
const MARQUEE_DURATION = `${CLIENT_LOGOS.length * 2.2}s`;

const HomeClients = () => (
  <div className="home-clients" aria-label="Our clients">
    <div
      className="home-clients__track"
      style={{ '--marquee-duration': MARQUEE_DURATION }}
    >
      {MARQUEE_LOGOS.map((logo, index) => (
        <div key={`${logo}-${index}`} className="home-clients__item">
          <img
            className="home-clients__logo"
            src={logo}
            alt={`Client logo ${(index % CLIENT_LOGOS.length) + 1}`}
            loading="lazy"
            draggable="false"
          />
        </div>
      ))}
    </div>
  </div>
);

export default HomeClients;
